import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder"]

import { Ref, ref, watchEffect } from 'vue'
import { isPhoneCode, isStringNumber } from 'src/common/helpers/validators'

interface IProps {
  externalLabel: string
  placeholder?: string
  codePlaceholder?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseContactNumber' },
  __name: 'BaseContactNumber',
  props: /*@__PURE__*/_mergeModels({
    externalLabel: {},
    placeholder: { default: '000 000 0000' },
    codePlaceholder: { default: '+00' }
  }, {
    "modelValue": { type: String, required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel(__props, "modelValue")

const entryRef: Ref<string[]> = ref([])
const codeRef: Ref<string> = ref('')
const numberRef: Ref<string> = ref('')
const isValidRef: Ref<boolean> = ref(true)

function handleModelValue() {
  if (codeRef.value && numberRef.value) {
    if (!isPhoneCode(codeRef.value)) isValidRef.value = false
    else if (!isStringNumber(numberRef.value)) isValidRef.value = false
    else {
      isValidRef.value = true
      model.value = `${codeRef.value}-${numberRef.value}`
    }
  } else isValidRef.value = false
}

function initInputValues() {
  entryRef.value = model.value.split('-').filter((entry) => entry !== '')
  codeRef.value = entryRef.value[0]
  numberRef.value = entryRef.value[1]
}

initInputValues()

watchEffect(() => {
  initInputValues()
})

return (_ctx: any,_cache: any) => {
  const _component_k_input = _resolveComponent("k-input")!
  const _directive_number = _resolveDirective("number")!

  return _withDirectives((_openBlock(), _createBlock(_component_k_input, {
    modelValue: numberRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((numberRef).value = $event)),
    "external-label": __props.externalLabel,
    placeholder: __props.placeholder,
    error: 'rules' in _ctx.$attrs ? undefined : !isValidRef.value,
    "error-message": 'rules' in _ctx.$attrs ? undefined : !isValidRef.value ? 'Contact number is not valid.' : '',
    class: "BaseContactNumber full-width",
    onChange: handleModelValue
  }, {
    prepend: _withCtx(() => [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeRef).value = $event)),
        class: "BaseContactNumber__input-code fs-15px fw-400 text-center q-pa-none",
        placeholder: __props.codePlaceholder,
        onChange: handleModelValue
      }, null, 40, _hoisted_1), [
        [_vModelText, codeRef.value],
        [_directive_number, '+']
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "BaseContactNumber__separator" }, null, -1))
    ]),
    _: 1
  }, 8, ["modelValue", "external-label", "placeholder", "error", "error-message"])), [
    [_directive_number]
  ])
}
}

})